var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AsyncComponent',{attrs:{"component-path":_vm.viewPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }